<template>
  <b-row>
    <b-col cols="12">
      <shift-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ShiftEditForm from './ShiftEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    ShiftEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
